import { ASSET_STATUS, IAsset, trackEvent } from "@desp-aas/desp-ui-fwk";
import { useEffect } from "react";

const ASSET_CREATION_DATE_KEY = 'asset_creation_date';

type IProps = {
    asset: IAsset | undefined;
}

const getAssetCreationAnalyticKey = (asset: IAsset) => {
    return ASSET_CREATION_DATE_KEY + `_${asset.id}`;
}
export const useAssetPageAnalytics = (props: IProps) => {

    useEffect(() => {
        if(
            props.asset &&
            props.asset.status === ASSET_STATUS.creation
        ){
            const now = new Date().toISOString();
            const analyticKey = getAssetCreationAnalyticKey(props.asset);
            const currentCreationDate = localStorage.getItem(analyticKey);
            if(!currentCreationDate){
                localStorage.setItem(analyticKey, now);
            }
            // trackEvent('asset', 'view', 'Asset page viewed', 1);
        }
    }, [ props.asset ])
}


export const trackAssetCreationAnalytics = (asset: IAsset) => {
    try{
        const analyticKey = getAssetCreationAnalyticKey(asset);
        const currentCreationDate = localStorage.getItem(analyticKey);
        if(currentCreationDate){
            trackEvent('asset_creation_time', 'asset_submitted', 'Time to submit an asset', Math.round((new Date().getTime() - new Date(currentCreationDate).getTime()) / 1000));
        }
    }
    catch(e){
        console.error('Error tracking asset creation analytics', e);
    }
}

export const removeAssetCreationAnalytics = (asset: IAsset) => {
    try{
        const analyticKey = getAssetCreationAnalyticKey(asset);
        localStorage.removeItem(analyticKey);
    }
    catch(e){
        console.error('Error removing asset creation analytics', e);
    }
}